import React from "react";

import { MascotFrame, skinTones } from "./MascotFrame";

export function GlindaArt({ className }: { className?: string }) {
  return (
    <MascotFrame
      className={className}
      backdropClassName="bg-mascot-backdrop-orange"
    >
      <g className="fill-orange-600">
        <path d="M13 22c0-8 5-13 11-13s11 5 11 13c0 7 2 12 3 17H10c1-5 3-10 3-17z" />
        <circle cx="11.5" cy="37" r="2.6" />
        <circle cx="36.5" cy="37" r="2.6" />
      </g>
      <path
        d="M11 48c0-8 5.5-12.5 13-12.5S37 40 37 48z"
        className="fill-gray-200"
      />
      <path
        d="M18 36.6 24 41l6-4.4c-1.8-.7-3.8-1.1-6-1.1s-4.2.4-6 1.1z"
        className="fill-white"
      />
      <path d="M16.5 42h15l.8 2.4H15.7z" className="fill-gray-400" />
      <rect
        x="21.5"
        y="29"
        width="5"
        height="6.5"
        className={skinTones.light}
      />
      <circle cx="24" cy="23" r="7" className={skinTones.light} />
      <path
        d="M17 22c1-5.5 4-8 7-8s6 2.5 7 8c-2.5-2-5-3-7-3.2S19.5 20 17 22z"
        className="fill-orange-600"
      />
      <path
        d="M17.6 18.4q6.4-3.6 12.8 0"
        className="fill-none stroke-yellow-400"
        strokeWidth="1.3"
        strokeLinecap="round"
      />
      <circle cx="21.3" cy="23.5" r=".9" className="fill-gray-800" />
      <circle cx="26.7" cy="23.5" r=".9" className="fill-gray-800" />
      <circle cx="19.9" cy="26" r="1.1" className="fill-red-200" />
      <circle cx="28.1" cy="26" r="1.1" className="fill-red-200" />
      <path
        d="M22 26.8q2 1.4 4 0"
        className="fill-none stroke-gray-800"
        strokeWidth="1"
        strokeLinecap="round"
      />
      <ellipse
        cx="24"
        cy="40.6"
        rx="2.8"
        ry="1.7"
        className={skinTones.light}
      />
    </MascotFrame>
  );
}
